export default () => !window.matchMedia('(hover: none)').matches
